import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IActiveLoan } from '../../interfaces';
import type { RootState } from '../store';

export interface IActiveLoanStore {
  loanInfo: IActiveLoan;
  isActiveLoanLoading: boolean;
  hasActiveLoanError: boolean;
}

const loanInfoDefault = { popup: null, promise_to_pay: null };

const initialState: IActiveLoanStore = {
  loanInfo: loanInfoDefault,
  isActiveLoanLoading: true,
  hasActiveLoanError: false,
};

export const loanSlice = createSlice({
  name: 'loan',
  initialState,
  reducers: {
    updateLoanAction: (state, action) => {
      state.loanInfo = { ...state.loanInfo, ...action.payload.loan };
    },
    setLoanLoading: (state, action: PayloadAction<boolean>) => {
      state.isActiveLoanLoading = action.payload;
    },
    setLoanError: (state, action: PayloadAction<boolean>) => {
      state.hasActiveLoanError = action.payload;
    },
    cleanupLoan: state => {
      state.loanInfo = loanInfoDefault;
    },
  },
});

export const { updateLoanAction, setLoanLoading, setLoanError, cleanupLoan } = loanSlice.actions;

export const selectLoan = (state: RootState) => state.loan;

export default loanSlice.reducer;
